import { Component, type ErrorInfo, type ReactNode } from "react";

interface State {
  readonly broken: boolean;
}

/**
 * Round the whole app: when a page breaks as it is drawn, the reader is told so in words and given the way
 * back, where they would otherwise be left looking at a blank page. Nothing of a game is lost by it: the game
 * is on the server, and loading the page again opens it where it stood.
 */
export class Crashed extends Component<{ readonly children: ReactNode }, State> {
  override state: State = { broken: false };

  static getDerivedStateFromError(): State {
    return { broken: true };
  }

  override componentDidCatch(error: Error, info: ErrorInfo): void {
    console.error(error, info.componentStack);
  }

  override render(): ReactNode {
    if (!this.state.broken) return this.props.children;
    return (
      <main className="loading" role="alert">
        <h1 className="page-title">Something went wrong on this page</h1>
        <p>
          Nothing of your game is lost: it is kept on the server. Load the page again to carry on where it stood. If it
          keeps happening, tell us what you were doing with "Report a problem" on the play screen.
        </p>
        <div className="control-row">
          <button className="button button-primary" onClick={() => window.location.reload()}>
            Load the page again
          </button>
          <a className="button" href="/">
            Back to Play
          </a>
        </div>
      </main>
    );
  }
}
